import { gql } from "@apollo/client";

export const CREATE_PAYMENT = gql`
  mutation createPayment($payment: CreatePaymentInput!, $saveDetails: Boolean, $collectDeposit: Boolean, $creditNotesToAdjust: [AdjustCreditNoteInput], $isConsolidated: Boolean, $convergePOSTransaction: Boolean) {
    createPayment(payment: $payment, saveDetails: $saveDetails, collectDeposit: $collectDeposit, creditNotesToAdjust: $creditNotesToAdjust, isConsolidated: $isConsolidated, convergePOSTransaction: $convergePOSTransaction) {
      success
      message
      payment {
        id
        booking {
          id
          depositDetails {
            payment {
              id
            }
          }
        }
        invoice {
          id
        }
        stripeCheckoutSessionId
        stripePaymentLinkUrl
        convergePaymentSessionUrl
        convergePaymentLinkUrl
        convergeUSSessionToken
      }
    }
  }
`;
